import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { formatDateHandler2 } from "utils/common";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import FilterSelect from "components/Form/filterSelect"
import { Button } from "components/Button";
import { changeEmployeeDetail } from "api/services/employee";

export const EmploymentDetails = ({ userData, userSalaryData, fetchInfo }) => {
  const [employmentData, setEmploymentData] = useState([]);
  const [salaryInfoData, setSalaryInfoData] = useState([]);
  const [filtereSalaryData, setFiltereSalaryData] = useState([]);
  const {
    user,
    userLoading
  } = useSelector((state) => state.user);
  const {
    position,
    positionLoading
  } = useSelector((state) => state.common);
  const [editDesignation, setEditDesignation] = useState(false)


  const [salaryTotals, setSalaryTotals] = useState()
  const [salarySeries, setSalarySeries] = useState()
  const [salaryLabels, setSalaryLabel] = useState()

  const [positionOption, setPositionOption] = useState([]);
  const [selectedPosition, setSelectedPosition] = useState("");


useEffect(()=>{
  
  let _position = position.map(item=> {
      return{
          label: item.name,
          value: item.id
      }
  })
  

  setPositionOption(_position)

},[position])



  useEffect(() => {
    const emp = [
      { id: 1, title: "Designation", text: userData?.employment?.position?.name },
      { id: 2, title: "Department", text: userData?.employment?.department?.name },
      // { id: 3, title: "Division", text: userData?.employment?.division?.name },
      { id: 4, title: "Joining Date", text: formatDateHandler2(userData?.employment?.employment_date) },
      { id: 5, title: "Confirmation Date", text: formatDateHandler2(userData?.employment?.confirmation_date) },
      { id: 6, title: "Position Start Date", text: formatDateHandler2(userData?.employment?.position_start_date) },
      { id: 7, title: "Leave Balance", text: userData?.employment?.leave_balance },
      { id: 8, title: "Leave Negative Days", text: userData?.employment?.leave_negative_days },
      { id: 9, title: "Number of Warnings", text: userData?.employment?.no_of_warnings },
      { id: 11, title: "Notice Period", text: userData?.employment?.notice_period },
      { id: 12, title: "Notice Period Start Date", text: formatDateHandler2(userData?.employment?.notice_period_start_date) },
      { id: 13, title: "Termination Date", text: formatDateHandler2(userData?.employment?.termination_date) },
      { id: 14, title: "Grade", text: userData?.employment?.grade?.grade_name || "-" },
      { id: 15, title: "Cost Center", text: `${userData?.cost_center?.code} - ` + userData?.cost_center?.name  || "-" },

    ];
    setEmploymentData(emp);

    // Update salary information
    setSalaryInfoData(userSalaryData);
    if(userSalaryData.amount) {

            
        // Filter salary data to ensure valid entries
          const filtereSalaryData = userSalaryData?.data?.filter(item => item?.Pay_Amount > 0 && item?.Pay_Name !== "Gratuity Accrual");
          setFiltereSalaryData(filtereSalaryData);

          const salarySeries = filtereSalaryData?.map(item => item.Pay_Amount) || [];
          setSalarySeries(salarySeries);

          const salaryLabels = filtereSalaryData?.map(item => item.Pay_Name) || [];
          setSalaryLabel(salaryLabels)

            const gratuityData = userSalaryData?.data?.find(item => item.Pay_Name == "Gratuity Accrual")
            console.log(userSalaryData, "userSalaryData")
            const salTotals = [
              {id:1, title: "Amount", text: "AED " + userSalaryData?.amount },
            // { id:2, title: "Gratuity Accural", text: "AED " + (gratuityData.Pay_Amount).toFixed(2)}
            ]
            setSalaryTotals(salTotals)
    }
   
   
  }, [userData, userSalaryData]);

  const donutChart = {
    chart: {
      height: 600,
      type: "donut",
      toolbar: {
        show: true,
      },
    },
    legend: {
      show: true, // Show legend at the bottom of the chart
      position: "bottom",
      labels: {
        useSeriesColors: true,
      },
      itemMargin: {
        horizontal: 5,
        vertical: 5,
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: "70%",
          labels: {
            show: false, // Hide default label inside donut
          },
        },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: function (value, { seriesIndex, w }) {      
        return `AED ${w.config.series[seriesIndex]}`;
      },
      style: {
        fontSize: "12px",
        colors: ["#333"], 
      },
      dropShadow: {
        enabled: false
      }
    },
    series: salarySeries,
    labels: salaryLabels,
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
        },
      },
    ],
  };

  const submitData = () => {
    changeEmployeeDetail( userData?.id, {position: selectedPosition}).then(response=> {
      setEditDesignation(false)

      fetchInfo()
    })
  }

  return (
    // <div className="tab-content">
      <div className="tab-pane fade" id="emp_projects">
        <div className="row">
          <div className="col-md-6 d-flex">
            <div className="card profile-box flex-fill">
             
              <div className="card-body">
                 {
                      (userData?.id !== user?.id && user?.role?.access_scope == "all") && 
                      <Link
                      to="#"
                      className="edit-icon"
                      onClick={()=>{
                        setSelectedPosition(userData?.employment?.position?.id)
                        setEditDesignation(true)}}
                    >
                      <i className="fa fa-pencil" />
                    </Link>
                    }
                <h3 className="card-title">Employment Information</h3>
                

                <ul className="personal-info">
                  {employmentData.map((item) => (
                    <ListItem key={item.id} title={item.title} text={item.text} userData={userData} user={user} editDesignation={editDesignation} positionOption={positionOption} positionLoading={positionLoading} selectedPosition={selectedPosition} setSelectedPosition={setSelectedPosition} submitData={submitData} setEditDesignation={setEditDesignation}/>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-6 d-flex">
            <div className="card profile-box flex-fill">
              <div className="card-body">
                <h3 className="card-title">Salary Information</h3>
                <ul className="personal-info">
                  {userSalaryData && salaryTotals?.map((item) => (
                    <ListItem key={item.id} title={item.title} text={item.text} />
                  ))}
                </ul>
                <div id="donut-chart" className="mt-4" />
                <div className="d-flex justify-content-center align-items-center" >
               { userSalaryData && salarySeries && <ReactApexChart
                  options={donutChart}
                  series={salarySeries}
                  type="donut"
                  height={450}
                />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    // </div>
  );
};

export const ListItem = ({ title, text,type, userData, user,editDesignation, positionOption, positionLoading, submitData, selectedPosition, setSelectedPosition , setEditDesignation}) => (
  <li className="align-items-center" >
    {
      (title == "Designation" && userData?.id !== user?.id && editDesignation ) ?
      <>
       <div className="title">{title}</div>
          <FilterSelect isClearable={true}  
          onChange={e=>{setSelectedPosition(e.value)}} 
          optionLabel={"label"} optionValue={'value'}  options={positionOption} isLoading={positionLoading} 
          value={positionOption.find(item=>item.value==selectedPosition)} 
          placeholder={"Change Designation"}/>
          <Button onClick={submitData} className="btn btn-sm btn-primary ms-1" label="Update" />
          <Button onClick={()=> setEditDesignation(false)} className="btn btn-sm btn-primary ms-1" label="X" />


</>
      :
      <>
       <div className="title">{title}</div>
    {(type=="mailto" || type=="tel") ? <a href={`${type}:${text}`} className="text">{text}</a> : <div className="text">{text}</div>  }
    
      </>
    }
    
   
  </li>
);
